module.exports = __webpack_public_path__ + "img/LF007-06.45b11a78.jpg";